<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenter"><a id="ch00_fm06"></a><a id="page_vii"></a><em>For Tones and Gabe</em></p>
<p class="publisher"><img alt="images" src="images/common.jpg"/><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm06.vue?65da612a